/**
 * App Reducers
 */
import { combineReducers } from 'redux'
import settings from './settings'

//OSSIF
import ossifDettaglioCrimineReducer from './ossif/ossifDettaglioCrimineReducer'
import ossifUtenteAuthReducer from './ossif/ossifUtenteAuthReducer'
import TokenReducer from './ossif-auth/TokenReducer'
import UserDataReducer from './ossif-auth/UserDataReducer'
const reducers = combineReducers({
  settings,
  gestioneDettaglioCrimineRdc: ossifDettaglioCrimineReducer,
  ossifUtenteAuthReducer: ossifUtenteAuthReducer,
  token: TokenReducer,
  userData: UserDataReducer
})

export default reducers
